import { AccessFlow } from './property-access.model';

/** Property shape embedded in bookings (guest-genie-backend BookingInfo.property). */
export interface BookingPropertyLocationModel {
  timezone: string;
  address: string;
  street: string;
  streetNumber: string;
  floor: string;
  apartment: string;
  city: string;
  state: string;
  country: string;
  postalCode: string;
  geometry: PropertyGeometryModel;
}

export interface BookingPropertyModel {
  _id: string;
  name: string;
  location: BookingPropertyLocationModel;
  images: string[];
  settings: {
    wifi: {
      ssid: string;
      password: string;
      securityType: string;
    };
    accessCode?: {
      enabled: boolean;
      smartLock?: {
        hasInternetConnection: boolean;
        hasGateway?: boolean;
        defaultAccessCodeId?: string;
      };
    };
  };
  organization: string;
  building: string | null;
  access?: AccessFlow;
  amenities: {
    externalId: string;
    name: string;
    description: string;
  }[];
  bedroom: {
    count: number;
    bedsCount: number;
  };
  bathroom: {
    count: number;
  };
  maxOccupancy: number;
  branding?: {
    logo?: string;
    cover?: string;
  };
}

/** Standalone property from GET /properties/:id (may include branding, etc.). */
export interface PropertyBedroomModel {
  _id?: string;
  count: number;
  bedsCount?: number;
}

export interface PropertyBathroomModel {
  _id?: string;
  count: number;
}

export interface PropertyModel {
  _id: string;
  name: string;
  description?: string;
  images: string[];
  organization: string;
  building: string;
  location: PropertyLocationModel;
  access?: AccessFlow;
  branding?: {
    logo?: string;
    cover?: string;
  };
  amenities?: string[] | BookingPropertyModel['amenities'];
  bedroom?: PropertyBedroomModel;
  bathroom?: PropertyBathroomModel;
  maxOccupancy?: number;
  settings: {
    wifi: {
      ssid: string;
      password: string;
      securityType: string;
    };
    accessCode?: {
      enabled: boolean;
      smartLock?: {
        hasGateway?: boolean;
        hasInternetConnection?: boolean;
        defaultAccessCodeId?: string;
      };
    };
  };
}

export interface PropertyLocationModel {
  address: string;
  city: string;
  state: string;
  country: string;
  postalCode: string;
  geometry: PropertyGeometryModel;
  street: string;
  streetNumber: string;
  floor: string;
  apartment: string;
  timezone: string;
}

export interface PropertyGeometryModel {
  lat: number;
  lng: number;
}

export interface PropertyAccessCodesModel {
  success: boolean;
  accessCode: string;
  buildingAccessCode: string;
  validFrom?: Date;
  validTo?: Date;
  showAccessCode?: {
    show: boolean;
    showAccessCodeHoursBefore: number;
    showAccessCodeHoursAfter: number;
  };
  isDefault?: boolean;
  error?: string;
}
